/* angular:styles/component:css;0aa62cc0e6b4d658d67259f91b206c3185f0736f42e1d7fdb76535412ed13132;/Users/incal/DOCKER/sir-server/on/efd/apps/efd-project/src/app/component/print-badges/print-badges.component.ts */
#main {
  padding: 0 0 important!;
}
/*# sourceMappingURL=print-badges.component.css.map */
